<template>
  <CBox id="navbar" top="0" pos="fixed" zIndex="1" h="6vw">
    <CBox d="flex" h="100%" alignSelf="center" color="black">
      <CBox
        display="flex"
        w="100vw"
        alignItems="center"
        justifyContent="space-between"
      >
        <CBox @click="navigateToHome">
          <CImage class="logo" h="6vw" :src="getLogo" />
        </CBox>

        <CBox display="flex" justifyContent="flex-end" alignItems="center">
          <CBox class="navMenus" display="flex" mx="2vw" w="100%">
            <CLink class="navMenuLink" as="router-link" to="/">
              <CBox
                as="button"
                rounded="0.5vw"
                fontSize="1vw"
                class="navMenuButton"
                p="0.5vw"
                m="2vw"
                v-if="!isHome"
              >
                Home
              </CBox>
            </CLink>
            <CLink
              class="navMenuLink"
              href="https://drive.google.com/drive/folders/18MnmkT7zxSIIdRStxHADuKcoICZxOffU?usp=sharing"
              target="_blank"
            >
              <CBox
                as="button"
                rounded="0.5vw"
                fontSize="1vw"
                class="navMenuButton"
                p="0.5vw"
                m="2vw"
              >
                Resume
              </CBox>
            </CLink>
            <CLink class="navMenuLink" as="router-link" to="/projects">
              <CBox
                as="button"
                rounded="0.5vw"
                fontSize="1vw"
                class="navMenuButton"
                p="0.5vw"
                m="2vw"
                v-if="!isProjects"
              >
                Projects
              </CBox>
            </CLink>
            <CLink class="navMenuLink" as="router-link" to="/contact">
              <CBox
                as="button"
                rounded="0.5vw"
                fontSize="1vw"
                class="navMenuButton"
                p="0.5vw"
                m="2vw"
                v-if="!isContact"
              >
                Contact
              </CBox>
            </CLink>
          </CBox>
        </CBox>
      </CBox>
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CLink } from "@chakra-ui/vue";
import { CImage } from "@chakra-ui/vue";
import Logo from "../assets/img/logo.png";

export default {
  name: "NavBar",
  components: {
    CBox,
    CLink,
    CImage,
  },
  computed: {
    getLogo() {
      return Logo;
    },
    isHome() {
      if (window.location.hash === "#/") {
        return true;
      }
      return false;
    },
    isProjects() {
      if (window.location.hash === "#/projects") {
        return true;
      }
      return false;
    },
    isContact() {
      if (window.location.hash === "#/contact") {
        return true;
      }
      return false;
    },
  },
  methods: {
    navigateToHome() {
      this.$router.push("/");
    },
  },
  mounted() {
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      var currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        document.getElementById("navbar").style.top = "0";
      } else {
        document.getElementById("navbar").style.top =
          -1 * parseInt(document.querySelector("#navbar").offsetHeight) + "px";
      }
      prevScrollpos = currentScrollPos;
    };
  },
};
</script>

<style>
.navMenuLink {
  outline: 0;
}

.navMenuButton {
  transition: all 0.1s ease;
}

.navMenuButton:hover {
  font-weight: bold;
  outline: 1px dotted black;
}

.logo {
  cursor: pointer;
}

#navbar {
  transition: all 0.15s ease-in-out;
}

@media screen and (max-width: 480px) {
  #navbar {
    height: 10vh;
  }
  .logo {
    height: 10vw;
  }
  .navMenuButton {
    font-size: 2.5vw;
  }
  .navMenus {
    width: 45vw;
    justify-content: space-around;
  }
}
</style>
